export const MILISECONDS_PER_DAY = 86400000;
